module.exports = __webpack_public_path__ + "img/authorize.net-integration.a08fb770.png";